import { render, staticRenderFns } from "./GrandTotal.vue?vue&type=template&id=08796bfc&scoped=true"
import script from "./GrandTotal.vue?vue&type=script&lang=js"
export * from "./GrandTotal.vue?vue&type=script&lang=js"
import style0 from "./GrandTotal.vue?vue&type=style&index=0&id=08796bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08796bfc",
  null
  
)

export default component.exports